import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const TeamBillingHistory = lazy(() => import('./TeamBillingHistory'))

class TeamBillingHistoryWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return []
	}

	override render() {
		return (
			<PageRoot>
				<TeamBillingHistory />
			</PageRoot>
		)
	}
}

customElements.define('team-billing-history', TeamBillingHistoryWebComponent)
